/**
 * The reason an aborted signal rejects with: the one the caller passed to `abort`,
 * or a native `AbortError` when the signal carries none.
 */
export function getAbortReason(signal: AbortSignal): unknown
{
	return signal.reason ?? new DOMException('The operation was aborted.', 'AbortError');
}
